import { AxiosError } from "axios";
import {
  agentsFilterConfig,
  appearanceFilterConfig,
  genderFilterConfig,
  heritageAndEthnicityFilter,
  IFilterValues,
  IOption,
  locationFilter,
  playingAgeFilter,
  useFilters,
} from "component-library";
import MakeSuggestionsView from "components/MakeSuggestionsView/MakeSuggestionsView";
import { ISuggestionsViewTexts } from "components/SuggestionsViewAgent/SuggestionsViewAgent.helpers";
import { HidePopup, ShowPopup } from "store/ui/ui.types";
import { mapGenderIdsToObject } from "./helpers/mapGenderIdsToObject";

interface IMakeSuggestionsViewWrapperProps {
  texts: ISuggestionsViewTexts;
  onToggleView: () => void;
  hidePopup: HidePopup;
  showPopup: ShowPopup;
  handleError: (e: AxiosError, message?: string) => void;
  roleId: string;
  genderIds: number[];
  breakdownId: string;
  appearanceIds: number[];
  location: IOption<string>[];
}

const MakeSuggestionsViewWrapper = (
  props: IMakeSuggestionsViewWrapperProps
) => {
  const genderFilterConfigWithDefaultValue = {
    ...genderFilterConfig,
    defaultValue: mapGenderIdsToObject(props.genderIds),
  };

  const filters = useFilters<IFilterValues>([
    agentsFilterConfig,
    genderFilterConfigWithDefaultValue,
    playingAgeFilter,
    appearanceFilterConfig,
    locationFilter,
    heritageAndEthnicityFilter,
  ]);

  return (
    <MakeSuggestionsView
      filters={filters}
      texts={props.texts}
      onToggleView={props.onToggleView}
      hidePopup={props.hidePopup}
      showPopup={props.showPopup}
      handleError={props.handleError}
      roleId={props.roleId}
      breakdownId={props.breakdownId}
      appearanceIds={props.appearanceIds}
      location={props.location}
    />
  );
};

export default MakeSuggestionsViewWrapper;
